import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { deleteMenuGroup, getMenuGroupPaging } from "./apiCall";
import { MenuGroupKeys } from "./entity";

export const MenuGroup = () => {
  const listOfMenuGroup = [
    {
      field: "DisplayName",
      headerName: "Display Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "LogoPath",
      headerName: "Logo Path",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "Sequence",
      headerName: "Sequence",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
  ];

  return (
    <CatalogBuilder
      headerLabel="Menu Group"
      headerButtonLabel="Add Menu Group"
      getPagingData={getMenuGroupPaging}
      pagingAPIKey={MenuGroupKeys.paging}

      onDelete={deleteMenuGroup}
      deletePagingAPIKey={MenuGroupKeys.delete}


      // pagingColumns={listOfMenuGroup}
      onModeClickPath="/menuGroup/details/"
    />
  );
};
